import customErrors from '../customErrors';

const GUMErrorHandler = (err) => {
    let error = null;
    if (err.name === 'OverconstrainedError' && err.constraint === 'deviceId') {
        // device id not matched
        error = customErrors.error_1142;
    } else if ((err.name == 'OverconstrainedError' || err.name == 'ConstraintNotSatisfiedError') && err.constraint === 'width') {
        //constraints can not be satisfied by devices
        error = customErrors.error_1147;
    } else if ((err.name == 'OverconstrainedError' || err.name == 'ConstraintNotSatisfiedError') && err.constraint === 'height') {
        //constraints can not be satisfied by devices
        error = customErrors.error_1148;
    } else if ((err.name == 'OverconstrainedError' || err.name == 'ConstraintNotSatisfiedError') && !err.constraint) {
        error = customErrors.error_1149;
    } else if (err.name == 'NotFoundError' || err.name == 'DevicesNotFoundError') {
        // Device not found
        error = customErrors.error_1143;
    } else if (err.name == 'NotReadableError' || err.name == 'TrackStartError') {
        //webcam or mic are already in use
        error = customErrors.error_1145;
    } else if (err.name == 'NotAllowedError' || err.name == 'PermissionDeniedError') {
        // Permission denied
        error = customErrors.error_1144;
    } else if (err.name == 'TypeError' || err.name == 'TypeError') {
        //empty constraints object
        error = customErrors.error_1146;
    } else {
        error = customErrors.error_1150;
    }
    return error;
};

export default GUMErrorHandler;



//////////////////
// WEBPACK FOOTER
// ./src/utils/ErrorHandler.js
// module id = 161
// module chunks = 0